import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            为什么选择开云登录
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            我们以安全为核心，以体验为导向，为用户提供业界领先的登录认证服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100/80 mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}